import React, { useState } from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import '../scss/components/_masonry-gallery.scss';

const MasonryGallery = ({ images, title, subtitle }) => {
  const [showLightbox, setShowLightbox] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setShowLightbox(true);
  };

  const closeLightbox = () => {
    setShowLightbox(false);
  };

  const goToPrevious = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goToPrevious();
    if (e.key === 'ArrowRight') goToNext();
  };

  return (
    <div className="masonry-gallery-section">
      {(title || subtitle) && (
        <div className="gallery-header text-center mb-5">
          {subtitle && (
            <p
              className="gallery-subtitle"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              {subtitle}
            </p>
          )}
          {title && (
            <h2
              className="gallery-title"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {title}
            </h2>
          )}
        </div>
      )}

      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4 }}>
        <Masonry gutter="20px">
          {images.map((image, index) => (
            <div
              key={index}
              className="masonry-item"
              onClick={() => openLightbox(index)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && openLightbox(index)}
              data-aos="zoom-in"
              data-aos-delay={100 + (index % 12) * 50}
              data-aos-duration="800"
            >
              <img
                src={image.src || image}
                alt={image.alt || `Galería imagen ${index + 1}`}
                className="masonry-image"
                onError={(e) => {
                  e.target.src = '/assets/stdominicana/images/placeholder.jpg';
                }}
              />
              <div className="image-overlay">
                <span className="zoom-icon">+</span>
              </div>
              {/* {image.caption && (
                <div className="image-caption">
                  <p>{image.caption}</p>
                </div>
              )} */}
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {/* Lightbox Modal */}
      <Modal
        show={showLightbox}
        onHide={closeLightbox}
        centered
        size="xl"
        className="lightbox-modal"
        onKeyDown={handleKeyDown}
      >
        <Modal.Body>
          <button className="close-btn" onClick={closeLightbox} aria-label="Cerrar">
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <button className="nav-btn prev-btn" onClick={goToPrevious} aria-label="Anterior">
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <div className="lightbox-image-wrapper">
            <img
              src={images[currentImage]?.src || images[currentImage]}
              alt={images[currentImage]?.alt || `Imagen ${currentImage + 1}`}
              className="lightbox-image"
            />
            {/* {images[currentImage]?.caption && (
              <div className="lightbox-caption">
                <p>{images[currentImage].caption}</p>
              </div>
            )} */}
          </div>

          <button className="nav-btn next-btn" onClick={goToNext} aria-label="Siguiente">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>

          <div className="image-counter">
            {currentImage + 1} / {images.length}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MasonryGallery;
